export default __webpack_public_path__ + "static/media/bg-banner-2.9c2997e9.jpg";